import { z } from 'zod';

export const changeInverterSerialNumberSchema = z.object({
  inverters: z.array(
    z.object({
      installed_inverter_id: z.string({
        required_error: 'ID do inversor instalado é obrigatório',
      }),
      serial_number_new: z
        .string({
          required_error: 'Número de série é obrigatório',
        })
        .trim()
        .min(3, 'Número de série deve ter no mínimo 3 caracteres')
        .max(100, 'Número de série deve ter no máximo 100 caracteres'),
    }),
  ).min(1, 'É necessário informar pelo menos um inversor'),
  ticket: z.string().optional(),
});

export type ChangeInverterSerialNumberForm = z.infer<typeof changeInverterSerialNumberSchema>;

